import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5883d725"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "month-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["timeline-month", { 
      'quarter-start': _ctx.isQuarterStart,
      'quarter-end': _ctx.isQuarterEnd,
      'selected': _ctx.isSelected
    }]),
    style: _normalizeStyle({ 
      backgroundColor: _ctx.quarterColor,
      '--month-color': _ctx.quarterColor
    }),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["stop"]))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.monthName), 1)
  ], 6))
}